export const BLUE = '#002B46'
export const RED = '#EE3338'


// WEBPACK FOOTER //
// ./src/constants/index.js